import { action } from 'satcheljs';
import ItemId from 'owa-service/lib/contract/ItemId';

/**
 * Action to delete an availability profile from the store.
 */
let deleteProfile = action('DELETE_AVAILABILITY_PROFILE', (itemId: ItemId) => ({
    itemId,
}));

export default deleteProfile;
